<template lang="pug">
    .timer-container
        .block(v-show='bdays')
            | {{ days | two_digits }}
        .block(v-show='bhours')
            | {{ hours | two_digits }}
        .block(v-show='bmins')
            | {{ minutes | two_digits }}
        .block :
        .block(v-show='bsecs')
            | {{ seconds | two_digits }}

    
</template>

<script>
export default {
    data: () => ({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }),
    created() {
        var timer = setInterval(() => {
            this.now = Math.trunc((new Date()).getTime() / 1000);
            if(this.days == 0 && this.hours == 0 && this.minutes == 0 && this.seconds == 0){
                this.$emit('deadline', true);
                clearInterval(timer);
            } 
        },1000);
    },
    destroyed(){
        console.log('Timer destruido');
    },
    props : {
        date : {
        },
        bdays: {
            type: Boolean,
            default: false
        },
        bhours: {
            type: Boolean,
            default: false
        },
        bmins: {
            type: Boolean,
            default: false
        },
        bsecs: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            now: Math.trunc((new Date()).getTime() / 1000)
        }
    },
    methods:{
        checkCounter(){
            if(this.days == 0 && this.hours == 0 && this.minutes == 0 && this.seconds == 0){
                this.$emit('deadline', true);
                return;
            } 
        }
    },
    computed: {
        dateIn() {
            return Math.trunc(Date.parse(this.date) / 1000);
        },
        seconds() {
            return (this.dateIn - this.now) % 60;
        },
        minutes() {
            return Math.trunc((this.dateIn - this.now) / 60) % 60;
        },
        hours() {
            return Math.trunc((this.dateIn - this.now) / 60 / 60) % 24;
        },
        days() {
            return Math.trunc((this.dateIn - this.now) / 60 / 60 / 24);
        }
    }
}
</script>

<style scoped>
.timer-container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 30px 20px 20px;
    text-align: center;
}
.timer-container .block{
    flex: 1;

    font-size: 1.5em;
}

</style>
